
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.476 22.672l10.625-10.625a1.867 1.867 0 012.649 0l1.765 1.765a1.867 1.867 0 010 2.649L22.992 24l7.531 7.531a1.867 1.867 0 010 2.649l-1.766 1.773a1.867 1.867 0 01-2.648 0L15.484 25.328a1.87 1.87 0 01-.008-2.656z","fill":"#535353"}})])
          )
        }
      }
    